import { render } from "./copyableModal.vue?vue&type=template&id=f6c8b150&ts=true"
import script from "./copyableModal.vue?vue&type=script&lang=ts"
export * from "./copyableModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__